// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BW_G","col":"styles_col__kWJwQ","actions":"styles_actions__VJX4u","conflict":"styles_conflict__7TFe2"};